export const initTicker = (): void => {
    const tickers = document.querySelectorAll<HTMLElement>('.ticker');

    tickers.forEach((ticker, index) => {
        const track = ticker.querySelector<HTMLElement>('.ticker-track');
        // track が存在しない、または既にクローン済み（再実行時）ならスキップ
        if (!track) return;

        // すでにクローンが追加されているかチェック（2回実行防止）
        const items = Array.from(track.children);
        if (items.length === 0) return;

        // 1セット分の幅を定義
        const pcWidth = 3048;
        const spWidth = 2286;
        const isSP = window.matchMedia('(max-width: 767px)').matches;
        const baseWidth = isSP ? spWidth : pcWidth;

        const speed = 35; // px/sec
        const duration = baseWidth / speed;

        // 初回実行時のみクローンを作成（子要素の数が元のままなら実行）
        // 既に track の中にクローンがある場合は、新しく追加しないようにガード
        if (track.getAttribute('data-cloned') !== 'true') {
            items.forEach(item => {
                const clone = item.cloneNode(true);
                track.appendChild(clone);
            });
            track.setAttribute('data-cloned', 'true');
        }

        // スクロール方向：通常（←）か逆方向（→）
        const isReverse = ticker.classList.contains('ticker-02');
        const animationName = `tickerScroll${index + 1}`;

        // 古いスタイルがあれば削除して、新しいスタイルを適用（リサイズ対策）
        const oldStyle = document.getElementById(`style-${animationName}`);
        if (oldStyle) oldStyle.remove();

        const style = document.createElement('style');
        style.id = `style-${animationName}`; // 削除できるように ID を付与
        style.innerHTML = `
            @keyframes ${animationName} {
                0% { transform: translateX(${isReverse ? -baseWidth : 0}px); }
                100% { transform: translateX(${isReverse ? 0 : -baseWidth}px); }
            }

            .ticker.ticker-0${index + 1} .ticker-track {
                animation: ${animationName} ${duration}s linear infinite;
                will-change: transform;
                display: flex;
                width: fit-content;
            }
        `;
        document.head.appendChild(style);
    });
};